let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gl0m3")).then(() => parcelRequire('f5s66'));